const GUEST_KEY = "zippyGuest";

export function adoptGuestFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const fromLink = params.get("guest");
  if (fromLink && /^[A-Za-z0-9-]{16,80}$/.test(fromLink)) {
    localStorage.setItem(GUEST_KEY, fromLink);
    params.delete("guest");
    const query = params.toString();
    window.history.replaceState({}, "", `${window.location.pathname}${query ? `?${query}` : ""}`);
  }
  let token = localStorage.getItem(GUEST_KEY);
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem(GUEST_KEY, token);
  }
  return token;
}

export function safeNext(fallback = "/") {
  const next = new URLSearchParams(window.location.search).get("next") || fallback;
  if (!next.startsWith("/") || next.startsWith("//")) {
    return fallback;
  }
  return next;
}
